import {
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
} from '@mui/material';
import React from 'react';

const WfhQuotaAccordian = (props) => {
  const { data } = props;

  const months = [
    { label: 'Jan Feb Mar', key: 0 },
    { label: 'Apr May Jun', key: 1 },
    { label: 'Jul Aug Sep', key: 2 },
    { label: 'Oct Nov Dec', key: 3 },
  ];

  const years = [
    { prevYear: new Date().getFullYear() - 1 },
    { thisYear: new Date().getFullYear() },
    { nextYear: new Date().getFullYear() + 1 },
  ];

  return (
    <>
      <AccordionDetails>
        {
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>

                  {months.map((month) => (
                    <TableCell key={month.key} align="center">
                      {month.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {years.map((year, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{year[Object.keys(year)[0]]}</TableCell>
                      {data.quotaWFH[Object.keys(year)[0]].map((val, id) => {
                        return (
                          <TableCell
                            key={id}
                            align="center"
                            style={{
                              backgroundColor: val > 6 ? 'yellowgreen' : '',
                            }}
                          >
                            {val}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        }
      </AccordionDetails>
    </>
  );
};

export default WfhQuotaAccordian;
